<!-- 创建时间2023/06/26 09:19:29 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：编辑 -->
<template>
  <div class="pr yxtbiz-flex" :class="module === 'kng' ? 'yxtbiz-kng-operator__single' : ''">
    <div class="yxtbiz-kng-operator__form-wrap">
      <div class="yxtbiz-w640">
        <template v-if="!hideFileHeader">
          <div id="info_0" class="yxtbiz-kng-operator__form-title ml15">
            {{ $t('pc_kng_upload_tit_upload'/**上传文件 */) }}
          </div>
          <div class="yxtbiz-flex-center mb32 ml15 lh40">
            <!-- 图标 -->
            <yxt-svg :remote-url="kngFileTypeIconUrl" width="20px" height="20px" :icon-class="typeIcon" />
            <span class="ellipsis-1 ml12 color-gray-9">{{
              info.fileName || info.title
            }}</span>
            <yxt-progress v-if="info._status === 0" class="ml32 yxtbiz-w100" :percentage="info._percentage"></yxt-progress>
            <div v-if="info._status === 1" class="ml32 yxtbiz-flex-shrink color-danger-6">
              {{ info._error }}
            </div>
            <template v-if="!useInBuyCourse && info.shareFlag !== 2">
              <yxt-button class="ml32" v-if="showReupload && !info._isReupload" type="text" @click="reupload">
                {{ $t('pc_biz_kng_lbl_reupload'/**重新上传 */) }}
              </yxt-button>
              <yxt-button v-if="showDelete" class="ml32" type="text" @click="del">
                {{ $t('pc_biz_kng_lbl_delete'/** 删除 */) }}
              </yxt-button>
              <yxt-button v-if="weikeVersionInfo.needUpgrade && !info.autoUpgrade" class="ml32" type="primary" :disabled="info.weiKeUpgrade" @click="updateWeike">
                {{ info.weiKeUpgrade ? $t('pc_kng_upload_lbl_newweike_newcontentversion_text3') : $t('pc_kng_lbl_updateweike'/** 更新到新版 */) }}
              </yxt-button>
              <yxt-button v-if="showWeikeEdit" class="ml32" type="text" @click="openWeikeUrl">
                {{ $t('pc_kng_upload_btn_editweikeonline'/** 编辑微课原文 */) }}
              </yxt-button>
            </template>
          </div>
        </template>

        <kng-form ref="form" :class="hideFileHeader? 'yxtbiz-kng-mt-44' : ''" :info="info" />
      </div>
    </div>
    <div v-if="module !== 'kng'" class="yxtbiz-flex-1"></div>
    <div class="yxtbiz-kng-operator__loc-wrap">
      <yxt-sticky class="yxtbiz-w105" :offset="getNavOffsetTop()">
        <div class="yxtbiz-kng-operator__loc">
          <div 
            v-for="(item, index) in steps" 
            :key="item.value" 
            class="hand" 
            :class="{ 'color-primary-6': step === item.value, mt16: index > 0 }"
            @click="jump(item)">
            {{ item.name }}
          </div>
          <div class="yxtbiz-kng-operator__loc-line">
            <div class="yxtbiz-kng-operator__loc-block" :style="style()"></div>
          </div>
        </div>
      </yxt-sticky>  
    </div>
    <yxt-dialog :visible.sync="showWeikeUpdateDialog" 
                :title="$t('pc_kng_upload_lbl_newweike_newcontentversion_dialog_title'/* 更新说明 */)"
                append-to-body
                width="580px">
      <p>{{ $t('pc_kng_upload_lbl_newweike_newcontentversion_dialog_text1'/* 1. 已完成的学员仅更新课件内容，完课状态、已发放的学时、学分不会退回 */) }}</p>
      <p>{{ $t('pc_kng_upload_lbl_newweike_newcontentversion_dialog_text2'/* 2. 进行中的学员会更新课件内容、学时、学分 */) }}</p>
      <p>{{ $t('pc_kng_upload_lbl_newweike_newcontentversion_dialog_text3'/* 3. 未开始的学员会直接使用新课件*/) }}</p>
      <span slot="footer" class="dialog-footer">
        <yxt-button @click="showWeikeUpdateDialog = false">{{ $t('pc_kng_common_btn_cancel') }}</yxt-button>
        <yxt-button type="primary" @click="conformUpdateWeike">{{ $t('pc_kng_upload_lbl_newweike_newcontentversion_dialog_btn_confirm'/* 确认更新*/) }}</yxt-button>
      </span>
    </yxt-dialog>
  </div>
</template>

<script>
import {
  getKngFileTypeIcon,
  kngFileTypeIconUrl
} from 'yxt-biz-pc/packages/select-kng/src/utils';
import { debounce } from 'throttle-debounce';
import { getScrollParent } from '../../utils';
import KngForm from './widget/kng-form.vue';
import { KNG_TYPE } from 'yxt-biz-pc/packages/select-kng/src/const';
import { getWeikeAuthurl, getWeikeInfo, getWeikeUpdateState } from '../../service';
export default {
  name: 'kng-from-single',
  components: {
    KngForm
  },
  inject: ['getIsEdit', 'getNavOffsetTop', 'getModule', 'getCollegeId', 'getUseInBuyCourse'],
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      kngFileTypeIconUrl,
      step: -1,
      weikeVersionInfo: {
        needUpgrade: false
      },
      showWeikeUpdateDialog: false,
      weikeInfo: {}
    };
  },
  computed: {
    isEdit() {
      return this.getIsEdit();
    },
    showDelete() {
      const { type } = this.info;
      return (!this.isEdit || this.info._isReupload) && type !== KNG_TYPE.WEIKE;
    },
    showWeikeEdit() {
      const { weikeType, type } = this.info;
      const { workType } = this.weikeInfo; // workType   图文:004   图片配音:005   微视频:007  文章:009   文档:008
      return weikeType === 1 && type === KNG_TYPE.WEIKE && ['004', '005', '007', '009', '008'].includes(workType);
    },
    showReupload() {
      const { newFileId, type } = this.info;
      return this.isEdit && !newFileId && type !== KNG_TYPE.WEIKE;
    },
    hideFileHeader() {
      const { type } = this.info;
      return type === KNG_TYPE.COURSE || type === KNG_TYPE.NEWLINK;
    },
    typeIcon() {
      const { fileType, type } = this.info;
      return getKngFileTypeIcon(fileType, type);
    },
    steps() {
      const base = [
        { value: 1, name: this.$t('pc_kng_kngcourse_menu_basic'/** 基本信息 */) },
        { value: 2, name: this.$t('pc_biz_kng_lbl_reletedinfo'/** 相关方信息*/) },
        { value: 3, name: this.$t('pc_biz_kng_lbl_authsetting'/** 权限设置 */) },
        { value: 4, name: this.$t('pc_biz_kng_lbl_funsetting'/** 功能设置*/) }
      ];
      if (!this.hideFileHeader) {
        base.unshift({ value: 0, name: this.$t('pc_kng_upload_tit_upload'/** 上传文件 */) });
      }
      return base;
    },
    validate() {
      return this.$refs.form && this.$refs.form.validate;
    },
    module() {
      return this.getModule();
    },
    useInBuyCourse() {
      return this.getUseInBuyCourse();
    }
  },
  watch: {
    'info.fileId': {
      immediate: true,
      handler(val) {
        if (val) this.initWeikeInfo();
      }
    }
  },
  created() {
    this.step = this.steps[0].value;
    this.scrollHandler = debounce(100, this.onScroll);
  },
  mounted() {
    this.scrollTarget = getScrollParent(this.$el);
    this.scrollTarget.addEventListener('scroll', this.scrollHandler);
    this.stepsScrollTop = this.steps.map(item => {
      return document.querySelector(`#info_${item.value}`).offsetTop;
    });
  },
  beforeDestroy() {
    if (this.scrollTarget) {
      this.scrollTarget.removeEventListener('scroll', this.scrollHandler);
    }
  },
  methods: {
    style() {
      const index = this.steps.findIndex(item => item.value === this.step);
      const wrap = document.querySelector('.yxtbiz-kng-operator__loc');
      const doms = wrap && wrap.getElementsByClassName('hand') || [];
      if (doms && doms.length) {
        const dom = doms[index];
        return { top: dom.offsetTop + 'px', height: dom.offsetHeight + 'px' };
      } else {
        return { top: 38 * index + 'px' };
      }
    },
    del() {
      if (this.info._abort) this.info._abort();
      if (this.info._isReupload) {
        this.info.fileType = this.info.oldFileType;
        this.info.newFileId = '';
        this.info.fileSize = '';
        this.info.fileName = '';
        this.info._uuid = '';
        this.info._isReupload = false;
        this.info._status = undefined;
        this.info._percentage = undefined;
        this.info._abort = undefined;
      } else {
        this.$emit('delete', this.info);
      }
    },
    reupload() {
      this.$root.$emit('reupload', this.info);
    },
    onScroll() {
      const scrollTop = this.scrollTarget.scrollTop;
      const length = this.stepsScrollTop.length;
      let step = 0;
      for (let i = 0; i < length; i++) {
        if (scrollTop + 10 >= this.stepsScrollTop[i]) {
          step = i;
        }
      }
      this.step = this.steps[step].value;
    },
    jump(item) {
      const dom = document.querySelector(`#info_${item.value}`);
      dom && dom.scrollIntoView();
      setTimeout(() => {
        this.step = item.value;
      }, 200);
    },

    initWeikeInfo() {
      const { type, autoUpgrade, weikeType, fileId } = this.info;
      if (type === KNG_TYPE.WEIKE && weikeType === 2 && !autoUpgrade && fileId) {
        getWeikeUpdateState(fileId).then(res => {
          this.weikeVersionInfo = res;
        });
      } else if (type === KNG_TYPE.WEIKE && weikeType === 1 && fileId && fileId.length === 32) {
        getWeikeInfo(fileId).then(res => {
          this.weikeInfo = res || {};
        });
      }
    },
    updateWeike() {
      this.showWeikeUpdateDialog = true;
    },
    conformUpdateWeike() {
      const {kngCourseCover, kngCourseDuration, kngCourseScore} = this.weikeVersionInfo;
      this.$set(this.info, 'weiKeUpgrade', true);
      this.info.coverUrl = kngCourseCover || '';
      this.info.studyHours = kngCourseDuration;
      this.info.kngCourseScore = kngCourseScore;
      this.showWeikeUpdateDialog = false;
    },
    async openWeikeUrl() {
      try {
        const collegeId = this.getCollegeId();
        const { fileId } = this.info;
        const { workType } = this.weikeInfo;
        const bodyParams = {
          applyType: '004', // 002：炫课创建 004：编辑作品
          from: collegeId ? `006--${collegeId}` : '001', // 001：后台课件管理 006企课堂课件管理
          workType,
          workId: fileId,
          webSite: window.location.host,
          https: document.location.protocol === 'https:' ? 1 : 0
        };
        const {url} = await getWeikeAuthurl(bodyParams).catch(error => { this.$message.error(error && error.error && error.error.message); });
        url && window.open(url);
      } catch (error) {

      }
    }
  }
};
</script>